var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoLocacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.165 6.835C13.165 9.37 9.93 13.25 8.34 14.57C7.935 14.905 7.35 14.895 6.955 14.545C5.46 13.205 2.5 9.355 2.5 6.835C2.5 3.61 4.61 1.5 7.835 1.5C11.06 1.5 13.17 3.61 13.17 6.835H13.165Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.835 9.39509C9.67963 9.39509 11.175 7.89972 11.175 6.05509C11.175 4.21046 9.67963 2.71509 7.835 2.71509C5.99036 2.71509 4.495 4.21046 4.495 6.05509C4.495 7.89972 5.99036 9.39509 7.835 9.39509Z",
    fill: "#D2D2D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocacion);
export default __webpack_public_path__ + "static/media/Ico_Locacion.58a414b90116247366c65ec7681f5e8d.svg";
export { ForwardRef as ReactComponent };